import { fillArr } from '@pinup-teams/common';

import {
  ChatMessageReaction,
  ChatMessageReplyTypes,
  ChatMessageStatus,
  GetMessagesReq,
  GetMessagesRes,
  SendQuestionReq,
  SendQuestionRes,
} from '../../../models';

type WindowExtended = Window & {
  questionErrorResponse: boolean;
  questionErrorTimeout: boolean;
};

export const getUserChatsMock = () => ({
  chats: [
    {
      id: '123123123',
      chatTitle: 'Title',
    },
  ],
});

export const getMessagesMock = (query: GetMessagesReq): GetMessagesRes => ({
  messages: fillArr(query.limit, (i) => ({
    id: `${query.offset}${i}`,
    chatId: '111',
    createdAt:
      'Mon Aug 12 2024 12:46:47 GMT+0200 (Central European Summer Time)',
    request: 'Какой процесс оценки',
    reaction: ChatMessageReaction.like,
    status: ChatMessageStatus.Delivered,
    lang: 'ru',
    reply:
      'Процесс оценки производительности в PinUp - это систематическая оценка профессионального уровня и рабочих результатов сотрудника. Он включает в себя обратную связь для помощи в развитии необходимых навыков для выполнения рабочих задач.',
    links: [
      {
        label: 'test [ru] Closing the Probation Period (Business)',
        url: 'https://wiki-n1.time2go.tech/pages/viewpage.action?pageId=10618528',
      },
      {
        label: '[ru] Jira & Confluence (Business) test',
        url: 'https://wiki-n1.time2go.tech/pages/viewpage.action?pageId=10618548',
      },
    ],
    replyType: ChatMessageReplyTypes.SIMPLE,
  })),
  total: 100,
});

export const sendMessageMock = (question: SendQuestionReq): SendQuestionRes => {
  const responseError = (window as unknown as WindowExtended)
    .questionErrorResponse;

  const timeoutError = (window as unknown as WindowExtended)
    .questionErrorTimeout;

  const isSuccessReply = !responseError && !timeoutError;

  return {
    id: question.messageId,
    chatId: '111',
    createdAt: new Date().toString(),
    request: question.request,
    status: timeoutError
      ? ChatMessageStatus.InProgress
      : ChatMessageStatus.Delivered,
    isSuccessReply,
    lang: 'uk',
    reply:
      'Процесс оценки производительности в PinUp - это систематическая оценка профессионального уровня и рабочих результатов сотрудника. Он включает в себя обратную связь для помощи в развитии необходимых навыков для выполнения рабочих задач.',
    links: [
      {
        label: 'test [ru] Closing the Probation Period (Business)',
        url: 'https://wiki-n1.time2go.tech/pages/viewpage.action?pageId=10618528',
      },
      {
        label: '[ru] Jira & Confluence (Business) test',
        url: 'https://wiki-n1.time2go.tech/pages/viewpage.action?pageId=10618548',
      },
    ],
    ppFullName: 'Valentyn Serhiiev',
    ppSlackId: 'U06T084ME91',
    replyType: ChatMessageReplyTypes.SIMPLE,
  };
};
